import { render } from "./VersionCheckPage.vue?vue&type=template&id=9c17a91a"
import script from "./VersionCheckPage.vue?vue&type=script&lang=js"
export * from "./VersionCheckPage.vue?vue&type=script&lang=js"

import "./VersionCheckPage.vue?vue&type=style&index=0&id=9c17a91a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__